import {INIT_URL, SET_SUBACCOUNT_USERS, FETCH_START_SUBACCOUNT_USER, FETCH_SUCCESS_SUBACCOUNT_USER, FETCH_ERROR_SUBACCOUNT_USER, SET_ACTION_SUBACCOUNT_USER } from "../../constants/ActionTypes";

const INIT_STATE = {
	initURL: "",
	options: null,
	action: null,
	subaccounts: null,
	error: null
};

export default (state = INIT_STATE, action) => {
	switch (action.type) {

	case INIT_URL: {
		return {...state, initURL: action.payload};
	}

	case SET_SUBACCOUNT_USERS: {
		return {
			...state,
			subaccounts: action.payload,
		};
	}
	case FETCH_START_SUBACCOUNT_USER: {
		return {...state, error: "", message: "", loading: true};
	}
	case FETCH_SUCCESS_SUBACCOUNT_USER: {
		return {...state, error: "", message: "", loading: false};
	}
	case FETCH_ERROR_SUBACCOUNT_USER: {
		return {...state, loading: false, error: action.payload, message: ""};
	}
	case SET_ACTION_SUBACCOUNT_USER: {
		return {
			...state,
			action: action.payload,
		};
	}
	default:
		return state;
	}
};
